<div class="login-page callback-page">
  <header class="login-header">
    <img
      class="login-logo"
      src="assets/reflact-logo.png"
      alt="reflact AG"
      width="172"
      height="36"
    >
    <span class="login-header-label">reflact ID</span>
  </header>
  <main class="login-main">
    <section
      class="login-content"
      aria-labelledby="callback-title"
      [attr.aria-busy]="!message"
    >
      <div class="login-eyebrow">
        <span
          class="login-accent"
          aria-hidden="true"
        ></span>
        <span i18n="@@callbackSecureSignIn">Ihre Anmeldung</span>
      </div>
      <h1 id="callback-title">reflact<span class="login-id"> ID</span><span class="login-period">.</span></h1>
      <div
        *ngIf="!message"
        class="callback-progress"
      >
        <p
          class="login-intro"
          role="status"
          i18n="@@callbackCompleting"
        >Anmeldung wird abgeschlossen.</p>
        <ol
          class="callback-steps"
          aria-label="Anmeldestatus"
          i18n-aria-label="@@callbackProgress"
        >
          <li
            [class.is-current]="step === 0"
            [class.is-complete]="step > 0"
            [attr.aria-current]="step === 0 ? 'step' : null"
          >
            <span
              class="callback-step-icon"
              aria-hidden="true"
            ><i [class]="step > 0 ? 'ri-check-line' : 'ri-shield-user-line'"></i></span>
            <span i18n="@@callbackIdentity">Identität bestätigen</span>
            <span
              *ngIf="step === 0"
              class="callback-spinner"
              aria-hidden="true"
            ></span>
          </li>
          <li
            [class.is-current]="step === 1"
            [class.is-complete]="step > 1"
            [attr.aria-current]="step === 1 ? 'step' : null"
          >
            <span
              class="callback-step-icon"
              aria-hidden="true"
            ><i [class]="step > 1 ? 'ri-check-line' : 'ri-key-2-line'"></i></span>
            <span i18n="@@callbackAccess">Zugang vorbereiten</span>
            <span
              *ngIf="step === 1"
              class="callback-spinner"
              aria-hidden="true"
            ></span>
          </li>
          <li
            [class.is-current]="step === 2"
            [attr.aria-current]="step === 2 ? 'step' : null"
          >
            <span
              class="callback-step-icon"
              aria-hidden="true"
            ><i class="ri-arrow-right-line"></i></span>
            <span i18n="@@callbackOpenPortal">Portal öffnen</span>
            <span
              *ngIf="step === 2"
              class="callback-spinner"
              aria-hidden="true"
            ></span>
          </li>
        </ol>
      </div>
      <div
        *ngIf="message"
        class="callback-error"
      >
        <p
          class="login-intro"
          i18n="@@callbackRetryTitle"
        >Ein neuer Versuch.</p>
        <p
          class="callback-error-message"
          role="alert"
        >
          <i
            class="ri-error-warning-line"
            aria-hidden="true"
          ></i>
          <span>{{ message }}</span>
        </p>
        <a
          routerLink="/login"
          pButton
          class="login-signin"
        >
          <span i18n="@@callbackBackToLogin">Zur Anmeldung</span>
          <i
            class="ri-arrow-right-line"
            aria-hidden="true"
          ></i>
        </a>
      </div>
    </section>
  </main>
  <footer class="login-footer">
    <span class="login-footer-brand">reflact<span aria-hidden="true"> / </span><span
        i18n="@@loginDigitalLearning">Digitales Lernen. Weitergedacht.</span></span>
    <nav
      class="login-legal"
      aria-label="Rechtliches"
      i18n-aria-label="@@loginLegal"
    >
      <a
        href="https://reflact.com/datenschutzerklaerung/"
        target="_blank"
        rel="noopener"
        i18n="@@privacy-policy"
      >Datenschutzerklärung</a>
      <a
        href="https://reflact.com/impressum/"
        target="_blank"
        rel="noopener"
        i18n="@@imprint"
      >Impressum</a>
    </nav>
  </footer>
</div>
